<template>
  <div class="main-contaienr">
    <div class="left">
      <!-- 整体数据统计 -->
      <div class="statistics leftchild">
        <cus-border title="整体数据统计" ref="blya1">
          <div class="statistics-group">
            <div
              class="statistics-item"
              v-for="(item, index) in statisticsList.cake"
              :key="index"
            >
              <statistics-item :item="item" />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 热门点位TOP5 -->
      <div class="hotPoint leftchild">
        <cus-border title="热门点位TOP5" ref="blya2">
          <div class="hotPoint-group">
            <div class="hotPoint-item">
              <hot-point />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 今日连接数量趋势 -->
      <div class="connection leftchild">
        <cus-border title="今日连接数量趋势" ref="blya3">
          <div class="connection-group">
            <div class="connection-item">
              <connection-number />
            </div>
          </div>
        </cus-border>
      </div>
    </div>

    <div class="right">
      <!-- 连接时长统计 -->
      <div class="connection-statistics rightChild">
        <cus-border title="连接时长统计" ref="blya4">
          <div class="connection-statistics-group">
            <div class="connection-statistics-item">
              <connection-statistics />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 手机厂商TOP10 -->
      <div class="phone-manufacturer rightChild">
        <cus-border title="手机厂商TOP10" ref="blya5">
          <div class="phone-manufacturer-group">
            <div class="phone-manufacturer-item">
              <phone-manufacturer />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 手机认证占比 -->
      <div class="certification-than rightChild">
        <cus-border title="手机认证占比" ref="blya6">
          <choice />
          <div class="certification-than-group">
            <div
              class="certification-than-item"
              v-for="(item, index) in certificationList"
              :key="index"
            >
              <certification-than :item="item" />
            </div>
          </div>
        </cus-border>
      </div>
    </div>
  </div>
</template>
<script>
  // 导入边框组件
  import cusBorder from '@/components/cus-border/cus-border'
  // 导入整体数据统计
  import statisticsItem from './components/statistics-item.vue'
  // 导入hotPoint5
  import hotPoint from './components/hot-point.vue'
  // 导入今日连接数量趋势
  import ConnectionNumber from './components/connection-number'
  // 导入今日连接数量趋势
  import ConnectionStatistics from './components/connection-statistics'
  // 手机厂商TOP10
  import PhoneManufacturer from './components/phone-manufacturer'
  // 手机认证占比
  import CertificationThan from './components/certification-than'
  import Choice from './components/choice'

  export default {
    components: {
      Choice,
      CertificationThan,
      PhoneManufacturer,
      ConnectionStatistics,
      ConnectionNumber,
      cusBorder,
      statisticsItem,
      hotPoint,
      // drawnMap,
    },
    data() {
      return {
        // 整体数据统计
        statisticsList: {
          cake: [
            {
              total: 874,
              number: 500,
              name: '当前Wi-Fi连接数',
              color: ['#092F57', '#298FF7'],
            },
            {
              total: 1649,
              number: 1649,
              name: '今日连接峰值',
              color: ['#42082A', '#F037A5'],
            },
            {
              total: 984432,
              number: 894432,
              name: '历史注册用户',
              color: ['#095931', '#00FF7E'],
            },
          ],
        },
        // 应急事件统计
        certificationList: [
          {
            val: 0.45,
            text: '微信',
            textColor: '#88E5D0',
            waveColor: ['rgba(0, 255, 162, 0.2)', 'rgba(0, 255, 162, 0.6)'],
            shadowColor: 'rgba(0, 255, 162, 0.15)',
            borderColor: 'rgba(0, 255, 162, 0.3)',
            position: 'left',
          },
          {
            val: 0.55,
            text: '免登录',
            textColor: '#8daeff',
            waveColor: ['rgba(141, 174, 255, 0.2)', 'rgba(141, 174, 255, 0.6)'],
            shadowColor: 'rgba(141, 174, 255, 0.15)',
            borderColor: 'rgba(141, 174, 255, 0.3)',
            position: 'right',
          },
        ],
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.$animejs.remove(['.svg-container', '.leftchild', '.rightChild'])
    },
    methods: {
      // 初始化
      init() {
        let anime = this.$animejs
        anime({
          targets: '.leftchild',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
          // scale: [
          //   { value: 0.8, easing: 'easeOutSine', duration: 500 },
          //   { value: 1, easing: 'easeInOutQuad', duration: 800 },
          // ],
          // delay: this.$animejs.stagger(100, { grid: [14, 5], from: 'center' }),
        })
        anime({
          targets: '.rightChild',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
        })
        window.onresize = () => {
          this.$refs.blya1.init()
          this.$refs.blya2.init()
          this.$refs.blya3.init()
          this.$refs.blya4.init()
          this.$refs.blya5.init()
          this.$refs.blya6.init()
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .main-contaienr {
    position: relative;
    display: flex;
    justify-content: space-between;

    .center-map {
      position: absolute;
      height: 100vh;
      width: 100vw;
      left: -1.0416vw;
      top: 0;
    }

    .left,
    .right {
      width: 23.59375vw;
      position: relative;
      z-index: 3;

      // 整体数据统计
      .statistics {
        height: 25vh;

        &-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          &-item {
            width: 28%;
          }
        }
      }

      // 热门点位TOP5
      .hotPoint {
        height: 28.8vh;
        margin: 1.5vh 0;

        .hotPoint-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .hotPoint-item {
            width: 100%;
          }
        }
      }

      // 今日连接数量趋势
      .connection {
        height: 28.8vh;
        margin: 1.5vh 0;

        .connection-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .connection-item {
            width: 100%;
          }
        }
      }

      // 整体数据统计
      .connection-statistics {
        height: 25vh;

        .connection-statistics-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .connection-statistics-item {
            width: 100%;
          }
        }
      }

      // 手机厂商TOP10
      .phone-manufacturer {
        height: 28.8vh;
        margin: 1.5vh 0;

        .phone-manufacturer-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .phone-manufacturer-item {
            width: 100%;
          }
        }
      }

      // 今日连接数量趋势
      .certification-than {
        height: 28.8vh;
        margin: 1.5vh 0;

        .certification-than-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .certification-than-item {
            width: 50%;
          }
        }
      }
    }

    .center {
      color: transparent;
      flex-grow: 1;
    }
  }
</style>
